import { Container, Row } from "reactstrap";
import DefaultRangeSlider from "./DefaultRangeSlider/DefaultRangeSlider";
import MinMaxValue from "./MinMaxValue/MinMaxValue";
import NegativeValue from "./NegativeValue/NegativeValue";
import Disabled from "./Disabled/Disabled";
import Prefix from "./Prefix/Prefix";
import FormateLabel from "./FormateLabel/FormateLabel";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, RangeTitle } from "../../../Constants/Constants";
import { Fragment } from "react/jsx-runtime";

const RangeSliderContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={RangeTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <DefaultRangeSlider />
          <MinMaxValue />
          <NegativeValue />
          <Disabled />
          <Prefix />
          <FormateLabel />
        </Row>
      </Container>
    </Fragment>
  );
};

export default RangeSliderContainer;
